export enum EstadoValidacaoDocumentoEnum {
  EM_VALIDACAO = 1,
  VALIDADO = 2,
  REJEITADO = 3,
}

export const ESTADO_VALIDACAO_LABEL: Record<number, { label: string; severity: 'secondary' | 'success' | 'danger' | 'info' | 'warn' }> = {
  [EstadoValidacaoDocumentoEnum.EM_VALIDACAO]: { label: 'Em Validação', severity: 'warn' },
  [EstadoValidacaoDocumentoEnum.VALIDADO]: { label: 'Validado', severity: 'success' },
  [EstadoValidacaoDocumentoEnum.REJEITADO]: { label: 'Rejeitado', severity: 'danger' },
};

export const TIPO_DOCUMENTO_LABEL: Record<string, string> = {
  CERTIFICADO_HABILITACOES: 'Certificado de Habilitações',
  DIPLOMA: 'Diploma Académico',
  PASSAPORTE: 'Passaporte',
  BI: 'Bilhete de Identidade',
  OUTRO: 'Outro Documento',
  CURRICULO: 'Curriculum Vitae (CV)',
  ATESTADO_MEDICO: 'Atestado Médico',
  REGISTO_CRIMINAL: 'Registo Criminal',
};

export function labelTipo(tipo?: string | { codigo?: string; nome?: string } | null): string {
  if (!tipo) return 'Documento';
  if (typeof tipo === 'string') {
    return TIPO_DOCUMENTO_LABEL[tipo] ?? tipo;
  }
  if (tipo.codigo && TIPO_DOCUMENTO_LABEL[tipo.codigo]) {
    return TIPO_DOCUMENTO_LABEL[tipo.codigo];
  }
  return tipo.nome || tipo.codigo || 'Documento';
}

export function formatarTamanhoBytes(bytes?: number | null): string {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return '—';
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const valor = parseFloat((bytes / Math.pow(k, i)).toFixed(1));
  return `${valor} ${sizes[i]}`;
}

export interface CandidatoDocumentoDto {
  id?: string;
  ativo?: boolean;
  candidatoId?: string;
  tipoDocumentoId?: string;
  tipoDocumento?: {
    id?: string;
    codigo?: string;
    nome?: string;
  };
  anexoId?: string;
  anexo?: AnexoCandidaturaDto;
  createdAt?: string;
  paisEmissorId?: string;
  codigoPaisEmissor?: string;
  codigoPais?: string;
  dataEmissao?: string;
  dataValidade?: string;
  tamanhoBytes?: number;
  estadoValidacaoEnum?: EstadoValidacaoDocumentoEnum | number;
  estadoValidacao?: string;
  motivoRejeicao?: string | null;
  validado?: boolean;
  validadoPor?: string | null;
  dataValidacao?: string | null;
}

export interface AnexoCandidaturaDto {
  id: string;
  candidaturaDocumentoId?: string;
  nomeFicheiro: string;
  mimeType: string;
  tamanho?: number;
  createdAt?: string;
  urlPreview?: string;
  linkAnexoPreview?: string;
  candidatoDocumentoId?: string;
  candidatoDocumento?: CandidatoDocumentoDto;
  tipoDocumentoId?: string;
  tipoDocumento?: string | {
    id?: string;
    codigo?: string;
    nome?: string;
  };
  // Propriedades calculadas/normalizadas para visualização
  estadoValidacaoEnum?: EstadoValidacaoDocumentoEnum | number;
  estadoValidacao?: string;
  motivoRejeicao?: string | null;
  validado?: boolean;
  validadoPor?: string | null;
  dataValidacao?: string | null;
}

export type EstadoDocumentoCandidatura = 'validado' | 'rejeitado' | 'pendente';

export function estadoDocumentoCandidatura(
  documento: Pick<AnexoCandidaturaDto, 'estadoValidacaoEnum' | 'estadoValidacao' | 'validado'>,
): EstadoDocumentoCandidatura {
  const estado = (documento.estadoValidacao ?? '').trim().toLocaleLowerCase();
  if (
    estado.includes('rejeit') ||
    estado.includes('não conforme') ||
    documento.estadoValidacaoEnum === EstadoValidacaoDocumentoEnum.REJEITADO ||
    documento.estadoValidacaoEnum === 4
  ) {
    return 'rejeitado';
  }
  if (
    (estado.includes('validado') && !estado.includes('não validado')) ||
    estado.includes('aprovado') ||
    estado === 'conforme' ||
    documento.estadoValidacaoEnum === EstadoValidacaoDocumentoEnum.VALIDADO ||
    documento.validado
  ) {
    return 'validado';
  }
  return 'pendente';
}

export interface ValidarCandidatoDocumentoItemDto {
  candidatoDocumentoId: string;
  estadoValidacaoEnum: EstadoValidacaoDocumentoEnum;
  motivoRejeicao: string | null;
}

export interface ValidacaoDocumentosResultadoDto {
  sucesso?: boolean;
  mensagem?: string | null;
  totalProcessados?: number;
  totalAlterados?: number;
  totalRejeitadosAlteracao?: number;
  documentosAtualizados?: CandidatoDocumentoDto[] | null;
  documentosNaoAlterados?: unknown[] | null;
  candidaturasAfetadas?: unknown[] | null;
}
